import { JoyIDWallet } from "../client/JoyIDWallet";

export class ViewData {
    static wallet: JoyIDWallet | null;
}